module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('column', {
    staticClass: "col-lg-3"
  }, [_c('va-box', {
    attrs: {
      "title": "Report Designer",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('h5', [_vm._v("Report Name:")]), _vm._v(" "), _c('Container', {
    staticStyle: {
      "padding": "10px",
      "border-bottom": "1px solid #f4f4f4"
    },
    attrs: {
      "group-name": "Header"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.Name),
      expression: "report.Name"
    }],
    staticStyle: {
      "width": "100%",
      "padding": "5px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.report.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "Name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("Orientation:")]), _vm._v(" "), _c('Container', {
    staticStyle: {
      "padding": "10px",
      "border-bottom": "1px solid #f4f4f4"
    },
    attrs: {
      "group-name": "Header"
    }
  }, _vm._l((_vm.orientationItems), function(item) {
    return _c('div', {
      staticClass: "tree-content tree--small",
      on: {
        "click": function($event) {
          _vm.orientation = item.name
        }
      }
    }, [_c('i', {
      class: ['tree-checkbox', _vm.orientation === item.name ? 'checked' : '']
    }), _vm._v(" "), _c('span', {
      staticClass: "tree-anchor",
      attrs: {
        "tabindex": "-1"
      }
    }, [_c('i', {
      class: [item.icon, item.class]
    }), _vm._v("   " + _vm._s(item.name) + "\n            ")])])
  }), 0), _vm._v(" "), (0 > 1) ? _c('h5', [_vm._v(_vm._s('Margins (' + _vm.marginsPx + ' inches):'))]) : _vm._e(), _vm._v(" "), (0 > 1) ? _c('Container', {
    staticStyle: {
      "padding": "10px",
      "border-bottom": "1px solid #f4f4f4"
    },
    attrs: {
      "group-name": "Header"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marginsPx),
      expression: "marginsPx"
    }],
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.marginsPx)
    },
    on: {
      "__r": function($event) {
        _vm.marginsPx = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v("Items:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "border-bottom": "1px solid #f4f4f4"
    },
    attrs: {
      "group-name": "Header"
    }
  }, _vm._l((_vm.controlItems), function(item, index) {
    return _c('div', {
      staticClass: "draggable-component",
      attrs: {
        "draggable": "true"
      },
      on: {
        "dragstart": function($event) {
          return _vm.dragStart(item, $event)
        }
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name) + "\n          ")])
  }), 0), _vm._v(" "), _c('h5', [_vm._v("Filters:")]), _vm._v(" "), _c('Container', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "group-name": "Header"
    }
  }, [_c('div', {
    staticClass: "tree-content tree--small",
    on: {
      "click": function($event) {
        _vm.report.Filters.FromDate = !_vm.report.Filters.FromDate
      }
    }
  }, [_c('i', {
    class: ['tree-checkbox', _vm.report.Filters.FromDate ? 'checked' : '']
  }), _vm._v("  From Date\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tree-content tree--small",
    on: {
      "click": function($event) {
        _vm.report.Filters.ToDate = !_vm.report.Filters.ToDate
      }
    }
  }, [_c('i', {
    class: ['tree-checkbox', _vm.report.Filters.ToDate ? 'checked' : '']
  }), _vm._v("  To Date\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tree-content tree--small",
    on: {
      "click": function($event) {
        _vm.report.Filters.Monthly = !_vm.report.Filters.Monthly
      }
    }
  }, [_c('i', {
    class: ['tree-checkbox', _vm.report.Filters.Monthly ? 'checked' : '']
  }), _vm._v("  Monthly\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tree-content tree--small",
    on: {
      "click": function($event) {
        _vm.report.Filters.DealerKey = !_vm.report.Filters.DealerKey
      }
    }
  }, [_c('i', {
    class: ['tree-checkbox', _vm.report.Filters.DealerKey ? 'checked' : '']
  }), _vm._v("  Dealer\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tree-content tree--small",
    on: {
      "click": function($event) {
        _vm.report.Filters.CustomerKey = !_vm.report.Filters.CustomerKey
      }
    }
  }, [_c('i', {
    class: ['tree-checkbox', _vm.report.Filters.CustomerKey ? 'checked' : '']
  }), _vm._v("  Customer\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tree-content tree--small",
    on: {
      "click": function($event) {
        _vm.report.Filters.SiteKey = !_vm.report.Filters.SiteKey
      }
    }
  }, [_c('i', {
    class: ['tree-checkbox', _vm.report.Filters.SiteKey ? 'checked' : '']
  }), _vm._v("  Site\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tree-content tree--small",
    on: {
      "click": function($event) {
        _vm.report.Filters.PrinterKey = !_vm.report.Filters.PrinterKey
      }
    }
  }, [_c('i', {
    class: ['tree-checkbox', _vm.report.Filters.PrinterKey ? 'checked' : '']
  }), _vm._v("  Printer\n          ")])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    staticClass: "btn btn-success btn-small",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "button",
      "value": "Save"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "button",
      "value": "Cancel"
    }
  })])])])])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-lg-9",
    staticStyle: {
      "background-color": "#525659",
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "reportPage",
    style: (_vm.reportCss)
  }, [(_vm.report) ? _c('ReportPage', {
    attrs: {
      "orientation": _vm.orientation,
      "reportDef": _vm.report.Definition
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "statusBar"
  }, [_c('row', [_c('column', {
    staticClass: "col-lg-2",
    staticStyle: {
      "border-right": "1px solid #bbb"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.shortText(_vm.report.Name, 40)))])]), _vm._v(" "), _c('column', {
    staticClass: "col-lg-10"
  }, [_c('column', {
    staticClass: "col-lg-6",
    staticStyle: {
      "border-right": "1px solid #bbb"
    }
  }, [_vm._v("Abed")]), _vm._v(" "), _c('column', {
    staticClass: "col-lg-6"
  }, [_c('column', {
    staticClass: "col-lg-3",
    staticStyle: {
      "border-right": "1px solid #bbb"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.shortText(_vm.activeElement.name, 20)))])]), _vm._v(" "), _c('column', {
    staticClass: "col-lg-4"
  }, [_c('column', {
    staticClass: "col-lg-2"
  }, [_vm._v("X:")]), _vm._v(" "), _c('column', {
    staticClass: "col-lg-4"
  }, [_c('b', [_vm._v(_vm._s(_vm.activeElement.x))])]), _vm._v(" "), _c('column', {
    staticClass: "col-lg-2"
  }, [_vm._v("Y:")]), _vm._v(" "), _c('column', {
    staticClass: "col-lg-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.activeElement.y))])])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-lg-5"
  }, [_c('column', {
    staticClass: "col-lg-3"
  }, [_vm._v("Width:")]), _vm._v(" "), _c('column', {
    staticClass: "col-lg-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.activeElement.w))])]), _vm._v(" "), _c('column', {
    staticClass: "col-lg-3"
  }, [_vm._v("Height:")]), _vm._v(" "), _c('column', {
    staticClass: "col-lg-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.activeElement.h))])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4274a230!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ReportDesigner.vue
// module id = 701
// module chunks = 0